export const COUPON_TYPES = {
  SLOT: 'บริการเช่าพื้นที่จัดเก็บลอตเตอรี่',
  DELIVER: 'บริการจัดส่งลอตเตอรี่',
}

export const COUPON_TYPES_NAME = {
  SLOT: 'SLOT',
  DELIVER: 'DELIVER',
}

export const COUPON_TYPES_UNIT = {
  SLOT: 'ช่อง',
  DELIVER: 'ซอง',
}

export const COUPON_TYPES_PRICE = {
  SLOT: 'ช่องละ',
  DELIVER: 'ซองละ',
}

export const COUPON_TYPES_AMOUNT = {
  SLOT: 'จำนวนช่อง',
  DELIVER: 'จำนวนซอง',
}

export const COUPON_TYPES_TOTAL_PRICE = {
  SLOT: 'ค่าช่องจัดเก็บลอตเตอรี่ (ไม่รวม VAT)',
  DELIVER: 'ค่าซองจัดส่งลอตเตอรี่ (ไม่รวม VAT)',
}

const COUPON_TYPES_CONST = {
  COUPON_TYPES,
  COUPON_TYPES_NAME,
  COUPON_TYPES_UNIT,
  COUPON_TYPES_PRICE,
  COUPON_TYPES_AMOUNT,
  COUPON_TYPES_TOTAL_PRICE,
}

export default COUPON_TYPES_CONST
